import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Alarms from '@/views/Alarms.vue'
import Production from '@/views/Production.vue'
import Energy from '@/views/Energy.vue'
import Reports from '@/views/Reports.vue'
import Configuration from '@/views/Configuration'
import Device from '@/views/Device'
import Login from '@/views/Login'
import NotFound from '@/views/NotFound'
import Users from '@/views/configuration/Users'
import Detentions from '@/views/configuration/Detentions'
import Flow from '@/views/flow/Flow'
import FlowForm from '@/views/flow/FlowForm'
import FlowBase from '@/views/flow/FlowBase'
import FlowBacklog from '@/views/flow/FlowBacklog'
import WMSDashboard from '@/views/wms/Dashboard'
import WMSStock from '@/views/wms/Stock'
import WMSPicking from '@/views/wms/Picking'
import WMSMovements from '@/views/wms/Movements'
import WMSLocations from '@/views/wms/Locations'
import store from '@/store/index'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/mtcontrol'
  },
  {
    path: '/mtcontrol',
    name: 'mtcontrol',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/mtcontrol/alarms',
    name: 'Alarmas',
    component: Alarms,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtcontrol/production',
    name: 'Producción',
    component: Production,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtenergy',
    name: 'Energía',
    component: Energy,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtcontrol/reports',
    name: 'Reportes',
    component: Reports,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtcontrol/device/:devid',
    name: 'Dispositivo',
    component: Device,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtwms',
    name: 'WMSDashboard',
    component: WMSDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtwms/stock',
    name: 'Stock',
    component: WMSStock,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtwms/picking',
    name: 'Picking',
    component: WMSPicking,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtwms/movements',
    name: 'Movimientos',
    component: WMSMovements,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtwms/locations',
    name: 'Ubicaciones',
    component: WMSLocations,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtflow',
    name: 'FlowDashboard',
    component: Flow,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtflow/base',
    name: 'FlowBase',
    component: FlowBase,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtflow/backlog',
    name: 'FlowBacklog',
    component: FlowBacklog,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mtflow/:blueprint',
    name: 'Formulario',
    component: FlowForm,
    meta: {
      requiresAuth: true
    }
  },
  { //test
    path: '*',
    name: 'notfound',
    component: NotFound
  },
  {
    path: '/configuration',
    name: 'Configuración',
    component: Configuration,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/configuration/users',
    name: 'Usuarios',
    component: Users,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/configuration/detentions',
    name: 'Detenciones',
    component: Detentions,
    meta: {
      requiresAuth: true
    }
  },
];

const router = new VueRouter({
  mode: 'history',
  //base: process.env.BASE_URL,
  base: '/v3/',
  routes
});

//NavigationDuplicated error
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach(async (to, from, next) => {
  const isLogged = store.getters.auth.result
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && (isLogged !== 'ok')) { //TODO: cambiar 'ok' por un parámetro booleano
    next({path: '/login', query: {redirect: to.fullPath}})
  } else {
    next()
  }
})

export default router;
